export const BUNDLE_CART_ACTIONS = {
  CHANGE_MAIL_ORDER_NO_OF_ACCOUNTS: "ChangeMailOrderNoOfAccounts",
  CHANGE_ORDER_PLAN: "ChangeOrderPlan",
  CREATE_ORDER: "CreateOrder",
  RENEW_BUNDLE: "RenewBundle",
  RENEW_ORDER_MANUAL_OLB: "RenewOrderManualOLB",
  REACTIVATE_ORDER: "ReactivateOrder",
  MAIL_ORDER_ADDON_PURCHASE: "MailOrderAddonPurchase",
  UPDATE_BUNDLE_FREE_TO_PAID: "UpdateBundleFreeToPaid",
};

export const BUNDLE_PAYMENT_TYPES = {
  CONTROL_PANEL_PURCHASE: "ControlPanelPurchase",
};
